import React, { Component } from "react";
import { render } from "react-dom";
import SiteNavbar from "./navbar/navbar.js";
import Footer from "./footer/footer.js";
import Home from "./homepage/home";
import OnlyMapPage from "./onlymappage.js";
import PSAPStatistic from "./map-section/statistic.js";
import StatisticEmbed from "./map-section/statistic-embed.js";
import JustMap from "./map-section/justmap.js";
import MapBox from "./map-section/map.js";
import "./style.scss";
import "./_skel.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import LandingPage from "./homepage/landingpage.js";
import { BrowserRouter as Router } from "react-router-dom";
import { Switch, Route, Routes } from "react-router-dom";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <LandingPage />
          </Route>
          <Route exact path="/embed">
            <OnlyMapPage />
          </Route>

          <Route exact path="/percentageembed">
            <StatisticEmbed />
          </Route>
        </Switch>
      </Router>
    );
  }
}

render(<App />, document.getElementById("root"));
